import { h, Fragment } from "preact";

export default function ProductOptionAvailabilityTooltip({
  tooltip,
  variant,
  alignment = "left",
}) {
  console.log(`variant`, variant);

  const handleClick = (e) => {
    const form = e.target.closest("form");
    const bisButtonWrapper = form.querySelector("back-in-stock-button");
    const bisButton = form.querySelector("[data-bis-button]");

    bisButtonWrapper.setAttribute(
      "selected-variant",
      variant.id.replace("gid://shopify/ProductVariant/", ""),
    );
    bisButton.focus();
    bisButton.click();
  };

  return (
    <info-tooltip
      class="product-options__availability-tooltip"
      data-alignment={alignment}
    >
      <details class="product-options__availability-tooltip-details">
        <summary class="product-options__availability-tooltip-summary">
          <span class="visually-hidden">More info</span>
        </summary>
        <div className="rte--simple" data-content>
          <button
            type="button"
            className="product-options__availability-tooltip-cta"
            onClick={handleClick}
            dangerouslySetInnerHTML={{
              __html: tooltip,
            }}
          ></button>
        </div>
      </details>
    </info-tooltip>
  );
}
